<div
  class="side-notifications"
  [ngClass]="{ open: isNotificationsOpen }"
  id="notifications-dialog"
  tabindex="-1"
  aria-modal="true"
>
  <div class="side-notifications__title">Notifications</div>
  <div class="side-notifications__actions">
    <div class="action action-mark" (click)="markAll()">
      <span class="txt">mark all as read</span>
    </div>
    <div class="action action-delete" (click)="deleteAll()">
      <span class="txt">delete all</span>
    </div>
  </div>
  @if (!pending) {
  <div class="notifications-list" (scroll)="onScroll($event)">
    @for (item of collection; track item) {
    <a360-notification-item
      class="notification-item-comp"
      (removed)="handleRemovedNotification($event)"
      (clicked)="close()"
      [isRead]="item.IsRead"
      [item]="item"
    >
    </a360-notification-item>
    } @if (isNextPageLoading) {
    <spinner class="next-page-spinner no-pad" size="small"></spinner>
    }
  </div>
  } @if (pending) {
  <spinner class="no-pad" size="small"></spinner>
  }
</div>
<div class="shadow-bg" [ngClass]="{ topnav: isPlatformTopNavEnabled }" (click)="close()" onkeypress="close()"></div>
